import { I18n } from '..';

export const tips = () => {
  const tipsList = [
    I18n.t('46birvUI'),
    I18n.t('4aSfQGiR')
  ];
  return tipsList;
}
